import BaseBusinessAPI from '../portal/baseBusinessAPI'
import httpClient from '@/apis/base/httpclient'

class EnrollmentStudentAPI extends BaseBusinessAPI {
  controllerName = 'EnrollmentStudents';

  /**
   * Kiểm tra xem đã tồn tại hồ sợ học sinh trong đợt tuyển sinh hay chưa
   * @param {*} model
   * @returns
   */
  getCountEnrollmentStudentInPeriod (model) {
    const request = {
      url: [this.getAPIUrl(), 'count'].join('/'),
      data: model,
    }
    return httpClient.getAsync(request)
  }

  /**
   * @description Lấy danh sách hồ sơ học sinh
   * @author PBac (16/12/2022)
   * @param {*} payload
   * @returns
   */
  getStudentProfile (payload) {
    const request = {
      url: this.getAPIUrl('profile'),
      data: payload,
    }
    return this.getAsync(request)
  }

  /**
   * @description Tìm kiếm hồ sơ học sinh
   * @author PBac (16/01/2022)
   * @param {*} payload
   * @returns
   */
  searchStudentProfile (payload) {
    const request = {
      url: this.getAPIUrl('profile/search'),
      data: payload,
    }
    return this.getAsync(request)
  }

  /**
   * @description Lịch sử tìm kiếm hồ sơ học sinh
   * @author PBac (11/01/2023)
   * @param {*} payload
   * @returns
   */
  getStudentProfileHistory (payload) {
    const request = {
      url: this.getAPIUrl('history'),
      data: payload,
    }
    return this.getAsync(request)
  }

  /**
   * Lấy danh sách kết quả đánh giá
   * @param {*} model
   * @returns
   */
  updateEnrollmentByIds (model) {
    const request = {
      url: [this.getAPIUrl(), 'update-enrollment-student'].join('/'),
      data: model,
    }
    return httpClient.postAsync(request)
  }

  /**
   * Lấy danh sách kết quả đánh giá
   * @param {*} model
   * @returns
   */
  updateEnrollmentStudent (model) {
    const request = {
      url: [this.getAPIUrl(), 'edit-enrollment'].join('/'),
      data: model,
    }
    return httpClient.postAsync(request)
  }

  /**
   * Tự động xếp lớp
   * @param {*} model
   * @returns
   */
  arrangeClass (model) {
    const request = {
      url: [this.getAPIUrl(), 'arrange-class'].join('/'),
      data: model,
    }
    return httpClient.postAsync(request)
  }

  /**
   * Chuyển nhóm tuyển sinh
   * @param {*} model
   * @returns
   */
  switchEnrollmentStudent (model) {
    const request = {
      url: [this.getAPIUrl(), 'switch-enrollment-group'].join('/'),
      data: model,
    }
    return httpClient.getAsync(request)
  }

  /**
   * Hủy kết quả xếp lớp
   * @param {*} payload
   * @returns
   */
  deleteClassArrangementResult (payload) {
    const request = {
      url: [this.getAPIUrl(), 'delete-class-arrangement-result'].join('/'),
      data: payload,
    }
    return httpClient.putAsync(request)
  }
}

export default new EnrollmentStudentAPI()
